/* ============================================================
   Raw Formula — product-card "Add to Cart"
   Injects a lower-center "Add to Cart" pill onto product cards
   (collection / home / related / search). One click adds the
   bottle and opens the cart drawer in place (Dawn's renderContents),
   so the drawer slides open with the new item + ladder/savings.
   Appless, self-contained. Loads on every page via the cart drawer.
   ============================================================ */
(function () {
  if (window.rfQuickAddInit) return;
  window.rfQuickAddInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {}; // handle -> Promise<{id, multi, available, url}>

  var BAG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

  function handleFrom(wrapper) {
    var a = wrapper.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = null;
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].available) { v = p.variants[i]; break; }
        }
        return {
          id: v ? v.id : (p.variants[0] && p.variants[0].id),
          multi: p.variants.length > 1,
          available: !!v,
          url: p.url
        };
      })
      .catch(function () { return null; });
    return cache[handle];
  }

  function getDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.getSectionsToRender === 'function' && typeof d.renderContents === 'function') return d;
    return null;
  }

  function refreshBubble() {
    fetch(root + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var el = document.getElementById('cart-icon-bubble');
        if (el && s && s['cart-icon-bubble']) el.innerHTML = s['cart-icon-bubble'];
      })
      .catch(function () {});
  }

  function build(handle) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rf-qa';
    btn.setAttribute('data-handle', handle);
    btn.setAttribute('aria-label', 'Add to cart');
    btn.innerHTML = BAG + '<span class="rf-qa__label">Add to Cart</span>';
    return btn;
  }

  function inject(root_el) {
    var scope = root_el || document;
    var wraps = scope.querySelectorAll('.product-card-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (w.dataset.rfQa) continue;
      w.dataset.rfQa = '1';
      // Skip sold-out cards (Dawn sold-out badge uses the sold-out colour scheme)
      if (w.querySelector('.badge.color-scheme-3')) continue;
      // Anchor the button to .card__media (Dawn's ratio/positioning box) —
      // NOT the inner .media. Making .media positioned re-anchors Dawn's
      // absolutely-positioned product image to a zero-height wrapper and
      // collapses the photo, so we must leave .media untouched.
      var media = w.querySelector('.card__media');
      var handle = handleFrom(w);
      if (!media || !handle) continue;
      media.appendChild(build(handle));
      // warm the variant lookup on first hover so the click feels instant
      w.addEventListener('pointerenter', function () {
        var h = this.getAttribute && this.getAttribute('data-handle');
        var hh = this.querySelector ? (this.querySelector('.rf-qa') || {}).getAttribute && this.querySelector('.rf-qa').getAttribute('data-handle') : null;
        if (hh) fetchProduct(hh);
      }, { once: true });
    }
  }

  function setLabel(btn, t) {
    var l = btn.querySelector('.rf-qa__label');
    if (l) l.textContent = t; else btn.textContent = t;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.rf-qa');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    var handle = btn.getAttribute('data-handle');
    if (!handle) return;

    var lbl = btn.querySelector('.rf-qa__label');
    var prev = lbl ? lbl.textContent : btn.textContent;
    function restore() { btn.disabled = false; btn.classList.remove('is-added'); setLabel(btn, prev); }

    btn.disabled = true;
    setLabel(btn, 'Adding…');

    fetchProduct(handle).then(function (info) {
      if (!info || !info.id) { restore(); return; }
      // Multi-variant products: send them to the page to choose.
      if (info.multi) { window.location.href = info.url; return; }
      if (!info.available) { setLabel(btn, 'Sold out'); return; }

      var drawer = getDrawer();
      var body = { items: [{ id: info.id, quantity: 1 }] };
      if (drawer) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) { restore(); return; }
          btn.classList.add('is-added');
          setLabel(btn, 'Added');
          if (drawer) {
            drawer.renderContents(res); // re-render drawer contents + open it
            // First add from an EMPTY cart: this theme keeps the `is-empty`
            // class on <cart-drawer>, and Dawn's renderContents only clears it
            // from .drawer__inner — so the header + items stay hidden (blank
            // drawer). Clear it on both so the content shows on the first add.
            drawer.classList.remove('is-empty');
            var di = drawer.querySelector('.drawer__inner');
            if (di) di.classList.remove('is-empty');
          } else {
            refreshBubble();
          }
          setTimeout(restore, 1400);
        })
        .catch(function () { restore(); });
    });
  });

  // ---- "Continue shopping" — secondary CTA injected into the drawer footer.
  // Injected (not in the Liquid) so it survives every drawer re-render and
  // works on the first add from an empty cart. Clicking it closes the drawer.
  function ensureContinue() {
    var ctas = document.querySelector('#CartDrawer .cart__ctas');
    if (!ctas || ctas.querySelector('.rf-continue')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rf-continue';
    b.textContent = 'Continue shopping';
    ctas.appendChild(b);
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('.rf-continue');
    if (!c) return;
    e.preventDefault();
    var d = c.closest('cart-drawer');
    if (d && typeof d.close === 'function') d.close();
  });

  // Drop the redundant "Taxes included." sentence from the drawer's tax note,
  // leaving "Discounts and shipping calculated at checkout." (matches /cart).
  function fixTaxNote() {
    var n = document.querySelector('#CartDrawer .tax-note');
    if (!n) return;
    var html = n.innerHTML;
    var cleaned = html.replace(/^\s*(?:Duties and taxes|Taxes)\s+included\.\s*/i, '');
    if (cleaned !== html) n.innerHTML = cleaned;
  }

  function decorate() { ensureContinue(); fixTaxNote(); }

  function start() {
    inject(document);
    decorate();
    // Re-apply drawer tweaks whenever Dawn re-renders the drawer.
    var cd = document.getElementById('CartDrawer');
    if (cd && window.MutationObserver) {
      new MutationObserver(function () { decorate(); }).observe(cd, { childList: true, subtree: true });
    }
    // Collection filtering / infinite scroll swap the grid — catch new cards.
    if (window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { inject(document); }, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
